import React, { useEffect, useState } from "react";
import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";
import Loading from "../components/common/Loading";

const SsoCallback = () => {
  return (
    <div className="min-h-[90vh] flex flex-col sm:flex-row justify-center items-center gap-2">
      <AuthenticateWithRedirectCallback />
      <Loading />
      <h1 className="text-sm font-semibold">Authenticating...</h1>
    </div>
  );
};

export default SsoCallback;
